<p>golden-record-stage works!</p>
